import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    
      // ❌ ProductSingleCategory → /products/:category/:id/:subcategory/:id
      // pathname.match(/^\/products\/[^/]+\/\d+\/[^/]+\/\d+$/) ||

      // ❌ ONLY brand landing page → /products/brand/:brandName
      // /^\/products\/brand\/[^/]+$/.test(pathname);;

  

    setTimeout(() => {
      document.documentElement.scrollTop = 0; // Chrome, Firefox
      document.body.scrollTop = 0; // Safari
    }, 100);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
